import {
  Heart,
  BriefcaseBusiness,
  Gem,
  Wallet,
  Star,
  Sparkles,
  Users,
  Home,
  BookOpen,
  Activity,
  MapPin,
  Hash,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface CategoryMeta {
  icon: LucideIcon;
  color: string;
}

export function getCategoryMeta(title: string): CategoryMeta {
  const t = title.toLowerCase();

  if (t.includes("love") || t.includes("relation"))
    return { icon: Heart, color: "#f43f5e" };
  if (t.includes("career") || t.includes("growth") || t.includes("work") || t.includes("job"))
    return { icon: BriefcaseBusiness, color: "#0284c7" };
  if (t.includes("marriage") || t.includes("wedding"))
    return { icon: Gem, color: "#d97706" };
  if (t.includes("finance") || t.includes("money") || t.includes("wealth") || t.includes("business"))
    return { icon: Wallet, color: "#16a34a" };
  if (t.includes("family") || t.includes("child"))
    return { icon: Users, color: "#0891b2" };
  if (t.includes("health") || t.includes("wellness"))
    return { icon: Activity, color: "#10b981" };
  if (t.includes("education") || t.includes("study") || t.includes("learning"))
    return { icon: BookOpen, color: "#8b5cf6" };
  if (t.includes("vastu") || t.includes("home"))
    return { icon: Home, color: "#6366f1" };
  if (t.includes("travel") || t.includes("foreign"))
    return { icon: MapPin, color: "#f97316" };
  if (t.includes("numer"))
    return { icon: Hash, color: "#ec4899" };
  if (t.includes("astro") || t.includes("kundli") || t.includes("vedic") || t.includes("horoscope") || t.includes("tarot"))
    return { icon: Star, color: "#eab308" };

  return { icon: Sparkles, color: "#8b5cf6" };
}
